{
  "title": "Receipt",
  "reprint": "Reprint",
  "print": "Print",
  "date": "Date",
  "time": "Time",
  "invoiceNumber": "Invoice number",
  "kind": {
    "CASH_SALE": "Cash sale",
    "DEBT_SALE": "Debt sale",
    "PURCHASE": "Purchase",
    "PAYMENT": "Payment",
    "RECEIPT": "Receipt",
    "DEBT_REPAYMENT": "Debt repayment"
  },
  "table": {
    "category": "Category",
    "qty": "Qty",
    "price": "Amount"
  },
  "lessJerrycans": "Less jerrycans",
  "total": "Total",
  "vehiclePlate": "Vehicle plate",
  "debtorName": "Customer name",
  "personName": "Person name",
  "statement": "Statement",
  "thankYou": "Thank you for your visit",
  "pricePending": "Awaiting pricing"
}
